var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bold fs22 pdBtm20 mrBtm20 borBtmdd"},[_vm._v("我的活动")]),_c('div',{staticStyle:{"padding":"10rem 0"}},[_c('el-empty',{attrs:{"description":"暂无活动"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }